import React from "react";
import { ConfirmationModalContainer } from "../Modal/ConfirmationModalContainer";
import { getValue } from "../../utils/object.utils";
interface Props {
  open: boolean;
  onClose: () => unknown;
  handleBlockRemove: () => unknown;
  selectedBranchToRemove: any;
  isProcessingConfirmation: boolean;
}

export const RemoveBlockModal = ({
  open,
  onClose,
  handleBlockRemove,
  selectedBranchToRemove,
  isProcessingConfirmation,
}: Props) => {
  const blockName = getValue(selectedBranchToRemove, "name", "");
  return (
    <ConfirmationModalContainer
      show={open}
      onClose={onClose}
      onSubmit={handleBlockRemove}
      isRemoving
      isProcessingConfirmation={isProcessingConfirmation}
    >
      <div>Do you want to remove {blockName} branch?</div>
    </ConfirmationModalContainer>
  );
};
